import { environment } from '../../environments/environment';
import { setRedirectCallback } from '../../utils/apiInterceptor';

const BASE_URL = environment.baseUrl;

export function setupApiErrorHandler(navigateFn) {
    setRedirectCallback(() => navigateFn('/'));
}

export async function loginUser(email, password) {
    const response = await fetch(`${BASE_URL}Default.aspx/Login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password })
    });

    return await response;
    // if(!response.ok) throw new Error('Login failed');
}
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}
export async function LogOut() {
    const response = await fetch(`${BASE_URL}logout.aspx/LogOut`, {
        method: 'POST',
        headers: { 'Accept': '*/*', 'Content-Type': 'application/json' },
        credentials: 'include',
    });
    return await response;
}
export async function isValidate() {
    try {
        const response = await fetch(`${BASE_URL}Default.aspx/Validation`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-Dc-Auth": getCookie("sckietman")
            },
            credentials: 'include'
        });
        const data = await response.json();
        return data;
    }
    catch (error) {
        console.error("Validation failed", error);
        return { success: false }
    }
    // return await response.json();
}
export async function GetAllUrls() {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/GetAvailableUrls`, {
        method: 'POST',
        headers: {
            "Accept": "*/*", 'Content-Type': 'application/json',
            "X-Dc-Auth": getCookie("sckietman"),
        },
        credentials: 'include',
    });
    return await response.json();
}
export async function fetchEventDetails(eventUrl) {
    try {
        const response = await fetch(`${BASE_URL}EventsNew.aspx/GetEventDetails`, {
            method: "POST",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json",
                "X-Dc-Auth": getCookie("sckietman"),
            },
            credentials: 'include',
            body: JSON.stringify({
                url: eventUrl,
            }),
        });
        if (!response.ok) throw new Error("Network error");
        return await response.json();
    }
    catch (error) {
        return error;
    }
}
export async function fetchEventMap(eventID) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/GetEventMap`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json"
        },
        credentials: 'include',
        body: JSON.stringify({
            eventID: eventID
        }),
    });
    //return await response.text();
    const data = await response.json();
    return data.d;
}
export async function fetchDropMap(eventID, sections) {
    const response = await fetch(`${BASE_URL}LiveFeeds.aspx/DropSectionMap`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json"
        },
        credentials: 'include',
        body: JSON.stringify({
            eventID: eventID,
            sections: sections
        }),
    });
    //return await response.text();
    const data = await response.json();
    return data.d;
}
export async function saveFilterDetails(filterDetails) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/SaveData`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "X-Dc-Auth": getCookie("sckietman"),
        },
        credentials: 'include',
        body: filterDetails
    });
    return await response.text();
}
export async function GetUserDataForUpdate(EventInfoId) {
    try {
        const response = await fetch(`${BASE_URL}EventsNew.aspx/GetUserDataForUpdate`, {
            method: "POST",
            headers: {
                "Accept": "*/*",
                "Content-Type": "application/json",
                "X-Dc-Auth": getCookie("sckietman"),
            },
            credentials: 'include',
            body: JSON.stringify({
                EventInfoId
            }),
        });
        return response.json();
    } catch (error) {
        return error;
    }
}
export async function updateFilterDetails(updatefilterDetails) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/SaveDataUpdate`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            "X-Dc-Auth": getCookie("sckietman"),
        },
        credentials: 'include',
        body: updatefilterDetails
    });
    return await response.json();
}
export async function PopulateEventData() {

    const response = await fetch(`${BASE_URL}EventsNew.aspx/PopulateEventData`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include"
    });
    return await response.json();

}
export async function ActivateEvents(EventInfoIds) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/ActivateNew`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
            // "X-Dc-Auth": getCookie("sckietman"),
        },
        credentials: 'include',
        body: JSON.stringify({
            DataKeyNames: EventInfoIds
        }),
    });
    return await response.json();
}
export async function DeleteEvents(EventInfoIds) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/MultipleDeleteNew`, {
        method: 'POST',
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
            DataKeyNames: EventInfoIds
        }),
    });
    return await response.json();
}
export async function GetAllDrops() {

    const response = await fetch(`${BASE_URL}LiveFeeds.aspx/LiveFeedDropsNew`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include"
    });
    return await response.json();

}

export async function GetSubscriptionData() {

    const response = await fetch(`${BASE_URL}Subscription.aspx/GetSubscriptionData`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include"
    });
    return await response.json();

}
export async function GetSettingData() {
    const response = await fetch(`${BASE_URL}Setting.aspx/UserDetails`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include"
    });
    return await response.json();
}

//-- Add Email --//
export async function AddEmail(email) {
    const response = await fetch(`${BASE_URL}Setting.aspx/AddEmails`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ Email: email })
    });
    return await response.json();
}
export async function RemoveEmail(email) {
    const response = await fetch(`${BASE_URL}Setting.aspx/DeleteEmail`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ Email: email })
    });
    return await response.json();
}
// Add Phone Number //
export async function AddPhoneNumber(phoneNumber) {
    const response = await fetch(`${BASE_URL}Setting.aspx/AddNumbers`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ Number: phoneNumber })
    });
    return await response.json();
}
export async function DeletePhoneNumber(phoneNumber) {
    const response = await fetch(`${BASE_URL}Setting.aspx/DeleteNumber`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ Number: phoneNumber })
    });
    return await response.json();
}
//-- Email and SMS alerts --//
export async function UpdateEmailAlert(emailAlert) {
    const response = await fetch(`${BASE_URL}Setting.aspx/EmailCheckBox`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ flag: emailAlert })
    });
    return await response.json();
}

export async function UpdateSMSAlert(smsAlert) {
    const response = await fetch(`${BASE_URL}Setting.aspx/SMSCheckBox`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ flag: smsAlert })
    });
    return await response.json();
}

export async function ChangePhoneNumber(newNumber) {
    const response = await fetch(`${BASE_URL}Setting.aspx/ChangePhone`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ Newphonenumber: newNumber })
    });
    return await response.json();
}

export async function ChangePassword(currentPass, newPass) {
    const response = await fetch(`${BASE_URL}Setting.aspx/UpdateNewPassword`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword: currentPass, newPassword: newPass })
    });
    return await response.json();
}

// Upcoming Events or Advance Seacrch Events 
export async function startsearch(eventname, eventvenue, city, state, remainSeats, fromDate, toDate, pageIndex) {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/startsearch`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ eventname: eventname, eventvenue: eventvenue, city: city, state: state, remainSeats: remainSeats, fromDate: fromDate, ToDate: toDate, index: pageIndex })
    });
    return await response.json();
}
export async function resetStartSearch() {
    const response = await fetch(`${BASE_URL}EventsNew.aspx/startsearch`, {
        method: "POST",
        headers: {
            "Accept": "*/*",
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ eventname: '', eventvenue: '', city: '', state: '', remainSeats: '', fromDate: '', ToDate: '', index: 0 })
    });
    return await response.json();
}
// Contact Us
export async function GetUserEmail() {
    const response = await fetch(`${BASE_URL}UserContact.aspx/GetUserEmail`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
    });
    return await response.json();
}
export async function SubmitContactUsForm(email, subject, message) {
    const response = await fetch(`${BASE_URL}UserContact.aspx/SendUserQuery`, {
        method: 'POST',
        headers: { "Accept": "*/*", 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: email, subject: subject, user_message: message })
    });
    return await response.json();
}


// export async function SignupUser(userName, FirstName, LastName, email, password, passwordCheck) {
//     const response = await fetch('https://example.com/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ userName, FirstName, LastName, email, password, passwordCheck })
//     });
//     if (!response.ok) throw new Error('Login failed');
//     return await response.json();
// }

